const VIMEO_REGEX = /vimeo\.com\/(?:video\/|channels\/[\w-]+\/|groups\/[\w-]+\/videos\/|manage\/videos\/)?(\d+)(?:\/([a-zA-Z0-9]+))?/;
const YOUTUBE_REGEX = /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

export function videoUrlToEmbedUrl(url: string): string | null {
  const vimeo = url.match(VIMEO_REGEX);
  if (vimeo) {
    // Privacy hash of unlisted videos — without it the player returns 403.
    // Path form (vimeo.com/<id>/<hash>) sits in group 2; player-URL form
    // carries it as ?h=<hash> instead.
    const hash = vimeo[2] || url.match(/[?&]h=([a-zA-Z0-9]+)/)?.[1];
    return `https://player.vimeo.com/video/${vimeo[1]}${hash ? '?h=' + hash : ''}`;
  }

  const youtube = url.match(YOUTUBE_REGEX);
  if (youtube) {
    return `https://www.youtube-nocookie.com/embed/${youtube[1]}`;
  }

  return null;
}

export function isVimeoPageUrl(url: string): boolean {
  return /^https?:\/\/(www\.)?vimeo\.com\//.test(url);
}

const oembedCache = new Map<string, Promise<string | null>>();

// Vanity URLs (vimeo.com/<account>/<slug>) carry no video id; Vimeo's public oEmbed
// endpoint resolves them for public videos. Unlisted videos 404 here — those need
// the numeric share link (vimeo.com/<id>/<hash>). Plain fetch() on purpose: the
// app's HTTP interceptors must not attach our JWT to a Vimeo request.
export function resolveVimeoOembedSrc(url: string): Promise<string | null> {
  let cached = oembedCache.get(url);
  if (!cached) {
    cached = fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(url))
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        const src = (data?.html?.match(/src="([^"]+)"/)?.[1] ?? '').replace(/&amp;/g, '&');
        return src.startsWith('https://player.vimeo.com/') ? src : null;
      })
      .catch(() => null);
    oembedCache.set(url, cached);
  }
  return cached;
}
